import { render, staticRenderFns } from "./BaseMitMenuHeader.vue?vue&type=template&id=02d52a3d&scoped=true"
import script from "./BaseMitMenuHeader.vue?vue&type=script&lang=js"
export * from "./BaseMitMenuHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d52a3d",
  null
  
)

export default component.exports